import {
  ActionOverRecordTypes,
  IActionsSchema,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  triggerAction,
  ZendraLocalizationServices,
} from '@zendra/shared';
import {
  STANDAREAMAINTENANCE_CONFIG,
  STANDAREAMAINTENANCE_FIELDS,
} from '../stand-area-maintenance/stand-area-maintenance.config';

export const STANDAREAMAINTENANCENOTUPDATED_FIELDS = STANDAREAMAINTENANCE_FIELDS;

export const STANDAREAMAINTENANCENOTUPDATED_ACTION_IDS = {
  ...STANDAREAMAINTENANCE_CONFIG.actionIds,
  updateAreasTrigger: 3,
};

export const STANDAREAMAINTENANCENOTUPDATED_ACTIONS_CONFIG: IActionsSchema = {
  overTable: [],
  multipleRecord: [
    triggerAction(
      STANDAREAMAINTENANCENOTUPDATED_ACTION_IDS.updateAreasTrigger,
      'Action.Trigger.UpdateAreas',
      ActionOverRecordTypes.MultipleRecord,
      ZendraLocalizationServices.Geographic,
    ),
  ],
  singleRecord: [],
};

export const STANDAREAMAINTENANCENOTUPDATED_CONFIG = {
  ...STANDAREAMAINTENANCE_CONFIG,
  entityName: 'StandAreaMaintenanceNotUpdated',
  localizationKey: 'Geographic::Entity.StandAreaMaintenance.NotUpdated',
  fields: STANDAREAMAINTENANCENOTUPDATED_FIELDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
  actions: STANDAREAMAINTENANCENOTUPDATED_ACTIONS_CONFIG,
  actionIds: STANDAREAMAINTENANCENOTUPDATED_ACTION_IDS,
};